export function createCookie(name, value, days) {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; expires=${date.toGMTString()}`;
  }
  const { href = '' } = location;
  let domain = '';
  const domainToBeUSed = getDomain(href);
  if (domainToBeUSed) {
    domain = `domain=.${domainToBeUSed}`;
  }
  // Add Secure flag for all environments except localhost
  const isLocalhost =
    typeof location !== 'undefined' &&
    (location.hostname === 'localhost' || location.hostname === '127.0.0.1');
  const secureFlag = isLocalhost ? '' : '; Secure';
  document.cookie = `${name}=${value}${expires}; path=/${domain}${secureFlag}`;
}

export function readCookie(name) {
  const nameEQ = `${name}=`;
  if (typeof document === 'undefined') {
    return null;
  }
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

export function eraseCookie(name) {
  createCookie(name, '', -1);
}

function getDomain(href) {
  const domainArr = ['ajio.com', 'ril.com'];
  for (let i = 0; i < domainArr.length; i++) {
    const domainToBeUSed = domainArr[i];
    if (href.toLowerCase().includes(domainToBeUSed)) {
      return domainToBeUSed;
    }
  }
  return '';
}

export function readCookieAtNode(req, cookieName) {
  if (req === null) return null;
  const { cookies = {} } = req;
  if (cookies.hasOwnProperty === undefined) return null;
  return cookies.hasOwnProperty(cookieName) ? cookies[cookieName] : null;
}
